import React from 'react';
import classnames from 'classnames';
import Spinner from '../Loader.jsx';

const SurveyPageSkeleton = () => {

  const classes = classnames(
    'surveyPage',
    'surveyPage--skeleton'
  );

  return (
    <div className={ classes }>
      <div className={`loader__skeleton_container`}>
        <Spinner></Spinner>
      </div>
    </div>
  );
};

export default SurveyPageSkeleton;
